import { Tooltip } from "antd";
import { ColumnType } from "antd/lib/table";
import { formatarDataSemTimezone, getMotivo } from "../utils";
import { MdOutlineAddCircle, MdFastForward, MdFastRewind, MdInfo, MdCancel, MdOutlineSwapHoriz, MdCheck } from "react-icons/md";
import { TimeLineIcon, Type, IconInfo } from "../styles";

const columns = (): ColumnType<any>[] => {

  let columnsShow: ColumnType<any>[] = [
    {
      title: "Timeline",
      dataIndex: "tipoAlteracao",
      align: "center",
      width: 20,
      render: (status: string) => {
        return (
          <span style={{ fontSize: 13 }}>
            {
              status.toLocaleLowerCase() === "antecipado" ? (
                <TimeLineIcon color="#3498db"><MdFastRewind /></TimeLineIcon>
              ) : status.toLocaleLowerCase() === "prorrogado" || status.toLocaleLowerCase() === "reaberto" ? (
                  <TimeLineIcon color="#f39c12">{status.toLocaleLowerCase() === "reaberto" ? <MdOutlineSwapHoriz /> : <MdFastForward />}</TimeLineIcon>
              ) : status.toLocaleLowerCase() === "cancelado" ? (
                <TimeLineIcon color="#e74c3c"><MdCancel /></TimeLineIcon>
              ) : <TimeLineIcon color="#27ae60">{status.toLocaleLowerCase() === "encerrado" ? <MdCheck /> : <MdOutlineAddCircle />}</TimeLineIcon>
            }
          </span>
        )
      },
    },
    {
      title: "Data e Hora",
      dataIndex: "dataCriacao",
      align: "center",
      width: 35,
      render: (_, dataValue: any) => {
        const newDate = dataValue.status === "Cancelada" ? dataValue.reagendamentoDataAtualizacao : dataValue.dataCriacao
        return (
          <span style={{ fontSize: 13 }}>{formatarDataSemTimezone(newDate) ?? "-"}</span>
        )
      },
    },
    {
      title: "Tipo de Alteração",
      dataIndex: "tipoAlteracao",
      align: "center",
      width: 35,
      render: (status: string) => {
        return (
          <span style={{ fontSize: 13 }}>
            {
              status.toLocaleLowerCase() === "antecipado" ? (
                <Type color="#3498db">{status}</Type>
              ) : status.toLocaleLowerCase() === "prorrogado" || status.toLocaleLowerCase() === "reaberto" ? (
                <Type color="#f39c12">{status}</Type>
              ) : status.toLocaleLowerCase() === "cancelado" ? (
                <Type color="#e74c3c">{status}</Type>
              ) : <Type color="#27ae60">{status}</Type>
            }
          </span>
        )
      },
    },
    {
      title: "Qtde. Dias",
      dataIndex: "reagendamentoQuantidadeDias",
      align: "center",
      width: 40,
      render: (value: number) => <span style={{ fontSize: 13, fontWeight: 500 }}>{value ?? "-"}</span>,
    },
    {
      title: "Data Inicial",
      dataIndex: "dataAnterior",
      align: "center",
      width: 30,
      render: (value: string) => <span style={{ fontSize: 13 }}>{formatarDataSemTimezone(value) ?? "-"}</span>,
    },
    {
      title: "Nova Data",
      dataIndex: "dataProgramada",
      align: "center",
      width: 30,
      render: (value: string, dataValue: any) => <span style={{ fontSize: 13 }}>{value ? formatarDataSemTimezone(value) : "-"}</span>,
    },
    {
      title: "Usuário Responsável",
      dataIndex: "usuario",
      align: "center",
      width: 50,
      render: (_, dataValue: any) => {
        const user = dataValue.status === "Cancelada" ? dataValue.usuarioReagendamento : dataValue.usuario
        return (
          <span style={{ fontSize: 13 }}>{user ?? "-"}</span>
        )
      },
    },
    {
      title: "Justificativa",
      dataIndex: "motivo",
      align: "center",
      width: 50,
      render: (value: string) => {
        return (
          <span style={{ fontSize: 13 }}>{getMotivo(value)}</span>
        )
      },
    },
    {
      title: "Obs.",
      dataIndex: "observacao",
      align: "center",
      width: 30,
      render: (value: string) =>
        <Tooltip title={value ?? "-"}>
          <IconInfo>
            <MdInfo />
          </IconInfo>
        </Tooltip>

    },
  ];

  return columnsShow;
}
export default columns;
